export type BenefitKeys = 'MedInsurance' | 'CorporateLife' | 'Bonus' | 'Education';

export enum OfferStatus {
  new = 'New',
  refused = 'Refused',
  accepted = 'Accepted',
}

export type UserData = {
  id: string;
  appointmentId: string;
  user: string;
  fullName: string;
  position: string;
  organizationalUnitName: string;
  employmentContract: string;
  managerName: string;
  managerPosition: string;
  workSchedule: string;
  workFormat: string;
  location: string;
  paidAnnualLeave: string | null;
  equipmentProvided: string | null;
  salary: string;
  salaryIncluding: string | null;
  annualBonus: string | null;
  semiAnnualBonus: string | null;
  quarterlyBonus: string | null;
  monthlyBonus: string | null;
  projectAward: string | null;
  pieceBonus: string | null;
  allowance: string | null;
  benefits: {
    title: string;
    items: string[];
    benefit_key: BenefitKeys;
  }[];
  action: string; // ISO 8601 дата
  actionEnds: string; // ISO 8601 дата
  recruiterName: string;
  recruiterTelephone: string;
  recruiterEmail: string;
  businessUnit: {
    id: string;
    businessUnit: string;
    habr: string;
    vk: string;
    telegram: string;
    dzen: string;
    newx5: string;
  };
  status: OfferStatus;
  mainTasks: string;
  startWorkDate: string;
};

export enum ActionButtonType {
  accept = 'accept',
  decline = 'decline',
}

export enum CardVariant {
  main = 'main',
  secondary = 'secondary',
  tertiary = 'tertiary',
  benefit = 'benefit',
  salary = 'salary',
}
